import { Form, FormInstance } from "antd";
import { useEffect } from "react";
import { INotificationRecipients } from "../types";
import { EMAIL_RULE } from "../../../lib/validationRules";
import { useUserTypesMap } from "./useUserTypesMap";

export const useSetErrorData = (
  form: FormInstance,
  receipients: INotificationRecipients[],
  setErrors: React.Dispatch<React.SetStateAction<string[] | null>>,
) => {
  const { userTypesMap } = useUserTypesMap();

  const selectedReceipients = Form.useWatch("notificationRecipientTypes", form);

  useEffect(() => {
    if (selectedReceipients) {
      const selectedTypes: number[] = [];

      const enries: any = Object.entries(userTypesMap);

      for (const [key, value] of enries) {
        if (selectedReceipients[value]) {
          selectedTypes.push(+key);
        }
      }

      const errors: string[] = [];

      if (selectedTypes.length === 0) {
        setErrors(null);
      } else {
        selectedTypes.forEach((i: number) => {
          const item = receipients.find(
            (item: INotificationRecipients) => item.userType === i,
          );

          if (item) {
            if (!item.email) {
              errors.push(`Email for ${item.name} is not specified.`);
            } else if (!EMAIL_RULE.test(item.email)) {
              errors.push(`Email ${item.email} is invalid.`);
            }
          }
        });

        setErrors(errors.length > 0 ? errors : null);
      }
    }
  }, [selectedReceipients, userTypesMap, setErrors, receipients]);
};
